import api from "@/utils/api";
import { createApi } from "@reduxjs/toolkit/query/react";
import { serializeQueryArgsExcludePrefetch } from "@/utils/prefetchUtils";

// Custom base query using your existing axios setup
const axiosBaseQuery =
  () =>
  async ({
    url,
    method,
    data,
    params,
    isPrefetchQuery = false,
    withCredentials = true,
  }) => {
    try {
      let result;

      // Set interceptorContext to bypass auth redirects for prefetch operations
      const interceptorContext = isPrefetchQuery
        ? {
            shouldIgnoreAuthFailure: true,
          }
        : undefined;

      switch (method.toLowerCase()) {
        case "get":
          result = await api.get(
            withCredentials,
            url,
            {},
            params,
            interceptorContext
          );
          break;
        case "post":
          result = await api.post(withCredentials, url, {}, data);
          break;
        case "put":
          result = await api.put(withCredentials, url, {}, data);
          break;
        case "patch":
          result = await api.patch(withCredentials, url, {}, data);
          break;
        default:
          throw new Error(`Unsupported method: ${method}`);
      }

      return { data: result };
    } catch (axiosError) {
      let err = axiosError;
      if (axiosError.response) {
        err = {
          status: axiosError.response.status,
          data: axiosError.response.data,
          message: axiosError.response.data?.message || axiosError.message,
        };
      }
      return {
        error: err,
      };
    }
  };

// Base API slice that you can extend for different domains
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery(),
  serializeQueryArgs: serializeQueryArgsExcludePrefetch,
  tagTypes: [
    "JobPages",
    "PublicJobPage",
    "JobBoards",
    "JobBoardJobPages",
    "JobClips",
    "Auth",
    "JobBoardDepartments",
    "JobBoardOffices",
    "JobPipelines",
    "JobPageApplications",
    "Persons",
    "PersonTags",
    "ContentPages",
    "PublicContentPage",
    "PublicSalesData",
    "PersonLists",
    "Sequences",
    "Users",
    "ScreeningSets",
    "Teasers",
    "Settings",
    "DocumentSignedUrls",
    "DailySpotlights",
    "SharedPermissions",
    "EmailConfig",
  ],
  endpoints: () => ({}),
});

export default baseApi;
